// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  line-height: 1;
}
:host .material-icons {
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/toggle-icon/toggle-icon.component.scss","webpack://./../../01.%20UI/NgHsSurveyClient/src/app/shared/toggle-icon/toggle-icon.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;ACCF;ADAE;EACE,cAAA;ACEJ","sourcesContent":[":host{\r\n  line-height: 1;\r\n  .material-icons {\r\n    display: block;\r\n  }\r\n}\r\n",":host {\n  line-height: 1;\n}\n:host .material-icons {\n  display: block;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
